<template>
    <div class="broadcast-ticker ticker loaded" 
		:class="ticker.primary.ticker_direction === 'left' ? 'ticker-left' : 'ticker-right'"
		:style="tickerBackground(ticker.primary.ticker_color)">

		<marquee-text :duration="60">
			<template v-if="ticker.primary.ticker_link && ticker.primary.ticker_link_text" >

				<span
				class="broadcast-ticker-item ticker-item fs-normal">
					<a :href="ticker.primary.ticker_link.url" target="_blank">
						{{ ticker.primary.ticker_link_text }}
					</a>
				</span>

				<span class="broadcast-ticker-item ticker-item fs-normal" 
					v-for="(item, idx) of ticker.items" :key="idx">

					{{ item.ticker_text }}

				</span>

				<span
				class="broadcast-ticker-item ticker-item fs-normal">
					<a :href="ticker.primary.ticker_link.url" target="_blank">
						{{ ticker.primary.ticker_link_text }}
					</a>
				</span>

				<span class="broadcast-ticker-item ticker-item fs-normal" 
					v-for="(item, idx) of ticker.items" :key="idx + 10">

					{{ item.ticker_text }}

				</span>
				
			</template>

			<template v-else>
			<span class="broadcast-ticker-item ticker-item fs-normal" 
				v-for="(item, idx) of [...ticker.items, ...ticker.items]" :key="idx">

				{{ item.ticker_text }}

			</span>
			</template>
			
		</marquee-text>

	</div>

</template>

<script>
export default {
    props: {
        ticker: Object
    },

    methods: {
        tickerBackground (tickerColor) {
			switch(tickerColor) {
				case 'bg-white':
					return 'background-color: #FFF';
				case 'bg-green':
					return 'background-color: #00FF00';
				case 'bg-blue':
					return 'background-color: #0200FF';
				case 'bg-red':
					return 'background-color: #FF0000; color: black !important;'
				case 'bg-yellow':
					return 'background-color: #f8e71c';
				case 'bg-pink':
					return 'background-color: #FF00FF'
				case 'black':
					return 'background-color: black; color: white;'
				default:
					return 'background-color: black; color: white;'
			}
		}
    }
}
</script>